import {Checkbox as AntCheckbox} from "antd";

export const Checkbox = AntCheckbox;
export default Checkbox;
